<template>
  <v-container class="py-10 px-8">
    <div>
      <v-btn @click="$router.go(-1)" text class="pl-0">
        <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
        <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <h2 class="display-1 font-weight-bold">Reporte Persona Moral</h2>
      </v-col>
    </v-row>
    <v-row class="mt-4" dense>
      <v-col cols="12" md="6" class="pa-3">
        <v-card style="border-radius: 16px;" class="mb-4">
          <h3 class="mb-3 px-4 py-2 white--text" style="background-color: black; font-family: 'montserrat-bold';">
            <v-icon left color="white">mdi-magnify</v-icon> Datos de Entrada
          </h3>
          <div class="pa-4">
            <div><strong>Razón o denominación social:</strong> {{ data?.razon_social }}</div>
            <div><strong>RFC:</strong> {{ data?.rfc }}</div>
            <div><strong>Marca:</strong> {{ data?.marca }}</div>
            <div><strong>Dominio:</strong> {{ data?.dominio }}</div>
          </div>
        </v-card>
        <v-card style="border-radius: 16px;" class="mb-4">
          <h3 class="mb-3 px-4 py-2 white--text" style="background-color: black; font-family: 'montserrat-bold';">
            <v-icon left color="white">mdi-clock-outline</v-icon> Información del reporte
          </h3>
          <div class="pa-4">
            <div><strong>Fecha y Hora de Búsqueda:</strong> {{ formatDate(data?.created_at) }}</div>
            <div><strong>No. de Reporte:</strong> {{ data?.sId }}</div>
            <div><strong>Estatus:</strong> {{ data?.status }}</div>
          </div>
        </v-card>
        <div>
          <p class="font-weight-medium mb-2">¿Quieres descargar tu reporte? Aquí puedes hacerlo.</p>
          <v-btn disabled rounded color="primary" class="mr-2" outlined>
            <v-icon left>mdi-download</v-icon> Descargar Reporte
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="pa-3">
        <v-card class="rounded-xl elevation-5" color="white" >
          <h3 class="mb-3 px-4 py-2 white--text" style="background-color: black; font-family: 'montserrat-bold';">
            <v-icon left color="white">mdi-robot</v-icon> Análisis del Reporte
          </h3>

          <v-card-text class="text-center" style="height: 400px; overflow-y: auto;">
            <div v-if="analysis" class="text--darken-3" style="white-space: pre-line; text-align: left; font-family: 'montserrat-semibold';">
              {{ analysis }}
            </div>

            <div v-else>
              <p class="mb-4 grey--text">
                Haz clic en el botón para generar un análisis con IA del reporte.
              </p>

              <v-btn
                :loading="loading"
                :disabled="loading"
                @click="analyzeWithAI"
                class="white--text font-weight-bold"
                style="background: linear-gradient(135deg, #00c6ff, #6b00b6);"
                rounded
                large
              >
                <span v-if="!loading" style="font-family: 'montserrat-bold';">Analizar con IA ✨</span>
                <span v-else>Cargando...</span>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

    <v-expansion-panels multiple class="mt-8">
      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          VALIDACIÓN DE EMPRESA
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                SAT (Servicio de Administración Tributaria)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="d-flex" style="font-family: 'montserrat-semibold';">
                  <div style="width: 100%;">
                    <h3 class="mb-1 mt-4" style="font-family: 'montserrat-bold';">RFC (Registro Federal de Contribuyentes)</h3>
                    <v-divider class="my-2"></v-divider>
                    <p class="mb-0"><strong style="font-family: 'montserrat-bold';">Resultado:</strong> {{ data?.data?.validacionEmpresa?.data?.estatus }}</p>
                    <p class="mb-0"><strong style="font-family: 'montserrat-bold';">RFC:</strong> {{ data?.data?.certificadosSAT?.data?.rfc }}</p>
                    <p><strong style="font-family: 'montserrat-bold';">Razón Social:</strong> {{ data?.data?.certificadosSAT?.data?.razon_social }}</p>
                  </div>
                </div>

                <div class="mt-6">
                  <h4 style="font-family: 'montserrat-medium';">Documentos:</h4>
                  <div style="max-height: 400px; overflow-y: auto;">
                    <v-row class="pa-4">
                      <v-col
                        v-for="(cert, index) in data?.data?.certificadosSAT?.data?.certificados"
                        :key="index"
                        cols="12"
                        md="6"
                        lg="4"
                      >
                        <v-card class="pa-4" style="border-radius: 12px; font-family: 'montserrat-medium';" elevation="5">
                          <p><strong>Número de Serie:</strong> {{ cert.numero_serie }}</p>
                          <p><strong>Estado:</strong> {{ cert.estado }}</p>
                          <p><strong>Tipo:</strong> {{ cert.tipo }}</p>
                          <p><strong>Fecha Inicial:</strong> {{ formatDate(cert.fecha_inicio) }}</p>
                          <p><strong>Fecha Final:</strong> {{ formatDate(cert.fecha_fin) }}</p>
                          <v-btn
                            v-if="cert.certificado"
                            color="primary"
                            class="mt-2"
                            rounded
                            @click="downloadCertificate(cert.certificado, cert.numero_serie)"
                            outlined
                          >
                            <v-icon left>mdi-file-download</v-icon>
                            Descargar .Cer
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                DENUE INEGI
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.DENUE?.data && data?.data?.DENUE?.data.length">
                  <v-container fluid>
                    <v-row
                      v-for="(empresa, index) in data?.data?.DENUE?.data"
                      :key="index"
                      class=" mt-3"
                    >
                      <v-col cols="12" md="6">
                        <p><strong>Nombre:</strong> {{ empresa.Nombre }}</p>
                        <p><strong>Razón Social:</strong> {{ empresa.Razon_social }}</p>
                        <p><strong>Clase de Actividad:</strong> {{ empresa.Clase_actividad }}</p>
                        <p><strong>Estrato:</strong> {{ empresa.Estrato }}</p>
                        <p><strong>Tipo:</strong> {{ empresa.Tipo }}</p>
                      </v-col>
                      <v-col cols="12" md="6">
                        <p><strong>Ubicación:</strong> {{ empresa.Ubicacion }}</p>
                        <p><strong>Colonia:</strong> {{ empresa.Colonia }}</p>
                        <p><strong>Calle:</strong> {{ empresa.Calle }}</p>
                        <p><strong>CP:</strong> {{ empresa.CP }}</p>
                        <p><strong>Teléfono:</strong> {{ empresa.Telefono }}</p>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <div v-else>
                  <p>Sin coincidencias encontradas.</p>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                RUG (Registro único de Garantías Mobiliarias)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.garantiasRUG?.data && data?.data?.garantiasRUG?.data.length">
                  <v-container fluid>
                    <v-card
                      v-for="(garantia, index) in data?.data?.garantiasRUG?.data"
                      :key="index"
                      class="pa-4"
                      elevation="2"
                      style="border-radius: 12px;"
                    >
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <p><strong>Número de Garantía:</strong> {{ garantia.numero_garantia }}</p>
                          <p><strong>Tipo de Bienes Muebles:</strong> {{ garantia.tipo_bienes_muebles }}</p>
                          <p><strong>Tipo de Garantía:</strong> {{ garantia.tipo_garantia }}</p>
                          <p><strong>Vigencia:</strong> {{ garantia.vigencia }}</p>
                          <p><strong>Monto:</strong> {{ garantia.monto }}</p>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <p><strong>Fecha Inscripción:</strong> {{ garantia.fecha_inscripcion }}</p>
                          <p><strong>Acreedor:</strong> {{ garantia.acreedor }}</p>
                          <p><strong>Folio Electrónico:</strong> {{ garantia.folio_electronico }}</p>
                          <p><strong>Operación:</strong> {{ garantia.operacion }}</p>
                          <p>
                            <strong>URL Operación:</strong>
                            <a :href="garantia.url_operacion" target="_blank">{{ garantia.url_operacion }}</a>
                          </p>
                        </v-col>

                        <v-col cols="12">
                          <p><strong>Otorgantes:</strong></p>
                          <ul>
                            <li v-for="(o, i) in garantia.otorgantes" :key="i">
                              {{ o.nombre_razon_denominacion_social }} ({{ o.tipo_persona }}) - RFC: {{ o.tiene_rfc }}
                            </li>
                          </ul>
                        </v-col>

                        <v-col cols="12">
                          <p><strong>Deudores:</strong></p>
                          <ul>
                            <li v-for="(d, i) in garantia.deudores" :key="i">
                              {{ d.nombre_razon_denominacion_social }} ({{ d.tipo_persona }})
                            </li>
                          </ul>
                        </v-col>

                        <v-col cols="12">
                          <p><strong>Descripción:</strong> {{ garantia.descripcion }}</p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-container>
                </div>
                <div v-else>
                  <p>Sin coincidencias encontradas.</p>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Registro Público de Comercio (SIGER)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6">
                      <p><strong>Razón Social:</strong> {{ data?.data?.SIGER?.data[0]?.razon_social }}</p>
                      <p><strong>Duración de la Sociedad:</strong> {{ data?.data?.SIGER?.data[0]?.duracion_sociedad }}</p>
                      <p><strong>Domicilio Social:</strong> {{ data?.data?.SIGER?.data[0]?.domicilio_social }}</p>
                      <p><strong>Nacionalidad:</strong> {{ data?.data?.SIGER?.data[0]?.nacionalidad }}</p>
                      <p><strong>RFC:</strong> {{ data?.data?.SIGER?.data[0]?.rfc || 'No disponible' }}</p>
                      <p><strong>Tipo de Persona:</strong> {{ data?.data?.SIGER?.data[0]?.tipo_persona }}</p>
                      <p><strong>Regimen Jurídico:</strong> {{ data?.data?.SIGER?.data[0]?.regimen_juridico }}</p>
                      <p><strong>Fecha de inscripción:</strong> {{ data?.data?.SIGER?.data[0]?.fecha_incripcion }}</p>
                      <p><strong>Entidad Federativa:</strong> {{ data?.data?.SIGER?.data[0]?.entidad_federativa }}</p>
                      <p><strong>Municipio:</strong> {{ data?.data?.SIGER?.data[0]?.municipio }}</p>
                      <p><strong>Oficina Registral:</strong> {{ data?.data?.SIGER?.data[0]?.oficina_registral }}</p>
                    </v-col>

                    <v-col cols="12" md="6">
                      <p><strong>Objeto Social:</strong></p>
                      <div style="max-height: 250px; overflow-y: auto; background-color: #f5f5f5; padding: 1rem; border-radius: 8px;">
                        <pre style="white-space: pre-wrap;">{{ data?.data?.SIGER?.data[0]?.objeto_social }}</pre>
                      </div>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4" />

                  <h3 class="text-h6 font-weight-bold mb-2">Socios ({{ data?.data?.SIGER?.data[0]?.numero_socios || 0 }})</h3>

                  <v-row v-if="data?.data?.SIGER?.data[0]?.nombre_socios && data?.data?.SIGER?.data[0]?.nombre_socios.length">
                    <v-col
                      v-for="(socio, index) in data?.data?.SIGER?.data[0]?.nombre_socios"
                      :key="index"
                      cols="12"
                      md="6"
                    >
                      <v-card outlined class="pa-3 mb-3">
                        <p><strong>Nombre:</strong> {{ socio.nombre }} {{ socio.apellido_paterno }} {{ socio.apellido_materno }}</p>
                        <p><strong>RFC:</strong> {{ socio.rfc }}</p>
                        <p><strong>CURP:</strong> {{ socio.curp }}</p>
                        <p><strong>Nacionalidad:</strong> {{ socio.nacionalidad }}</p>
                        <p><strong>Estado:</strong> {{ socio.estatus }}</p>
                        <p><strong>Fecha de nacimiento:</strong> {{ socio.fecha_nacimiento || 'N/D' }}</p>
                        <p><strong>Acciones:</strong> {{ socio.acciones }}</p>
                        <p><strong>Total:</strong> {{ socio.total }}</p>
                        <p><strong>Valor:</strong> {{ socio.valor }}</p>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row v-else>
                    <v-col cols="12">
                      <p>No se encontraron socios registrados.</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                IMPI (Instituto Mexicano de la Propiedad Industrial)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.IMPI?.data?.length">
                  <div style="max-height: 400px; overflow-y: auto;">
                    <v-row dense v-for="(marca, index) in data?.data?.IMPI?.data" :key="index" class="mb-4" >
                      <v-col cols="12" >
                        <v-card elevation="1" class="pa-4">
                          <v-row>
                            <v-col cols="12" md="6">
                              <p><strong>Marca:</strong> {{ marca.name }}</p>
                              <p><strong>Número de expediente:</strong> {{ marca.generalData?.expedientNumber }}</p>
                              <p><strong>Tipo de solicitud:</strong> {{ marca.requestType }}</p>
                              <p><strong>Estatus:</strong> {{ marca.status }}</p>
                            </v-col>

                            <v-col cols="12" md="6">
                              <p><strong>Razón social:</strong> {{ marca.headlineData?.name }}</p>
                              <p><strong>Dirección:</strong> {{ marca.headlineData?.address }}</p>
                              <p><strong>País:</strong> {{ marca.headlineData?.country }}</p>
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="my-2"></v-divider>
                              <p class="text-subtitle-2 font-weight-bold mb-2">Trámites:</p>

                              <v-row dense v-if="marca.procedures && marca.procedures.length">
                                <v-col v-for="(proc, idx) in marca.procedures" :key="idx" cols="12" md="6">
                                  <v-card outlined class="pa-3 mb-2">
                                    <p><strong>Descripción:</strong> {{ proc.description }}</p>
                                    <p><strong>Fecha inicio:</strong> {{ proc.startDate }}</p>
                                    <p><strong>Fecha conclusión:</strong> {{ proc.conslutionDate || 'Pendiente' }}</p>
                                    <v-btn
                                      v-if="proc.image"
                                      :href="proc.image"
                                      target="_blank"
                                      color="primary"
                                      small
                                      rounded
                                      class="mt-2"
                                      prepend-icon="mdi-file-image"
                                    >
                                      Ver Imagen
                                    </v-btn>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          LISTAS NEGRAS
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                SAT 69 Contribuyentes No Localizados
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.sat69?.data?.length">
                  <v-row dense v-for="(contribuyente, index) in data?.data?.sat69?.data" :key="index" class="mb-3">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <p><strong>RFC:</strong> {{ contribuyente.rfc.toUpperCase() }}</p>
                        <p><strong>Razón Social:</strong> {{ contribuyente.razon_social }}</p>
                        <p><strong>Tipo de Persona:</strong> {{ contribuyente.tipo_persona === 'm' ? 'Moral' : 'Física' }}</p>
                        <p><strong>Supuesto:</strong> {{ contribuyente.supuesto }}</p>
                        <p><strong>Primera Publicación:</strong> {{ contribuyente.fecha_primera_publicacion }}</p>
                        <p><strong>Entidad Federativa:</strong> {{ contribuyente.entidad_federativa }}</p>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                SAT 69B Contribuyentes Boletinados
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.sat69B?.data?.length">
                  <v-row dense v-for="(contribuyente, index) in data?.data?.sat69B?.data" :key="index" class="mb-3">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <p><strong>RFC:</strong> {{ contribuyente.rfc }}</p>
                        <p><strong>Nombre:</strong> {{ contribuyente.nombre_contribuyente }}</p>
                        <p><strong>Situación:</strong> {{ contribuyente.situacion_contribuyente }}</p>

                        <p class="mt-2"><strong>Presunción:</strong></p>
                        <ul>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_presuncion }}</li>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_presuntos }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_presuntos }}</li>
                        </ul>

                        <p class="mt-2"><strong>Desvirtuados:</strong></p>
                        <ul>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_desvirtuados || 'N/A' }}</li>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_desvirtuaron || 'N/A' }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_desvirtuaron || 'N/A' }}</li>
                        </ul>

                        <p class="mt-2"><strong>Definitivos:</strong></p>
                        <ul>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_definitivos || 'N/A' }}</li>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_definitivos || 'N/A' }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_definitivos || 'N/A' }}</li>
                        </ul>

                        <p class="mt-2"><strong>Favorable:</strong></p>
                        <ul>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_favorable }}</li>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_favorable }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_favorable }}</li>
                        </ul>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                SAT 74 Reducción de Multas
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.sat74?.data.length">
                  <v-row dense v-for="(registro, index) in data.data.sat74.data" :key="index" class="mb-3">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <p><strong>RFC:</strong> {{ registro.rfc }}</p>
                        <p><strong>Razón Social:</strong> {{ registro.razon_social }}</p>
                        <p><strong>Tipo de Persona:</strong> {{ registro.tipo_persona === 'm' ? 'Moral' : 'Física' }}</p>
                        <p><strong>Supuesto:</strong> {{ registro.supuesto }}</p>
                        <p><strong>Fecha de Autorización:</strong> {{ registro.fecha_autorizacion }}</p>
                        <p><strong>Monto Autorizado:</strong> ${{ Number(registro.monto).toLocaleString() }}</p>
                        <p><strong>Fecha de Publicación:</strong> {{ registro.fecha_publicacion }}</p>
                        <p><strong>Entidad Federativa:</strong> {{ registro.entidad_federativa }}</p>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                OFAC (Oficina de Control de Activos Extranjeros)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.OFAC?.data?.resultados?.length">
                  <v-row dense v-for="(persona, index) in data?.data?.OFAC?.data?.resultados" :key="index" class="mb-4">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <p><strong>Nombre:</strong> {{ persona.nombres }} {{ persona.apellidos }}</p>
                        <p><strong>Alias:</strong>
                          <span v-if="persona.alias?.length">
                            <span v-for="(alias, i) in persona.alias" :key="i">
                              {{ alias.nombre }} <span v-if="i < persona.alias.length - 1">|</span>
                            </span>
                          </span>
                          <span v-else>No disponible</span>
                        </p>
                        <p><strong>Nacionalidad:</strong> {{ persona.nacionalidad }}</p>
                        <p><strong>Ciudadanía:</strong> {{ persona.citizen }}</p>
                        <p><strong>Lugar de nacimiento:</strong> {{ persona.lugar_nacimiento }}</p>
                        <p><strong>Fechas de nacimiento:</strong> {{ persona.dia_nacimiento }}</p>
                        <p><strong>Tipo:</strong> {{ persona.tipo }}</p>
                        <p><strong>Lista:</strong> {{ persona.lista }}</p>
                        <p><strong>Programa:</strong> {{ persona.programa }}</p>

                        <v-divider class="my-3"></v-divider>

                        <div v-if="persona.identificadores?.length">
                          <p><strong>Identificadores:</strong></p>
                          <ul>
                            <li v-for="(id, i) in persona.identificadores" :key="i">
                              <strong>{{ id.tipo }}:</strong> {{ id.id }} <span v-if="id.pais">({{ id.pais }})</span>
                            </li>
                          </ul>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <div v-if="persona.direcciones?.length">
                          <p><strong>Direcciones:</strong></p>
                          <ul>
                            <li v-for="(direccion, i) in persona.direcciones" :key="i">
                              {{ direccion.domicilio }}, {{ direccion.ciudad }}, {{ direccion.estado }}, {{ direccion.pais }}
                            </li>
                          </ul>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          ANTECEDENTES JUDICIALES
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="data?.data?.getAntecedentesJudiciales?.data?.resultados?.length">
            <v-row dense v-for="(entidad, i) in data?.data?.getAntecedentesJudiciales?.data?.resultados" :key="i" class="mb-4">
              <v-col cols="12">
                <v-card outlined class="pa-4" style="overflow-y: scroll; max-height: 400px;">
                  <h4 class="text-primary mb-2">Entidad: {{ entidad.entidad }}</h4>

                  <v-divider class="my-2" />

                  <v-row v-for="(exp, j) in entidad.expedientes" :key="j" class="mb-4">
                    <v-col cols="12">
                      <v-card flat class="pa-3" color="grey lighten-4">
                        <p><strong>Expediente:</strong> {{ exp.expediente }}</p>
                        <p><strong>Actor:</strong> {{ exp.actor }}</p>
                        <p><strong>Demandado:</strong> {{ exp.demandado }}</p>
                        <p><strong>Juzgado:</strong> {{ exp.juzgado }}</p>
                        <p><strong>Tipo:</strong> {{ exp.tipo || 'No especificado' }}</p>
                        <p><strong>Fuero:</strong> {{ exp.fuero }}</p>
                        <p><strong>Fecha:</strong> {{ exp.fecha }}</p>

                        <v-expansion-panels multiple elevation="0" class="mt-2">
                          <v-expansion-panel>
                            <v-expansion-panel-header>Acuerdos</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ul>
                                <li v-for="(acuerdo, k) in exp.acuerdos" :key="k">
                                  <strong>{{ acuerdo.fecha }}:</strong> {{ acuerdo.acuerdo || 'Sin detalle del acuerdo' }}
                                </li>
                              </ul>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <template v-else>
            <p>Sin antecedentes judiciales encontrados.</p>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          IDENTIDAD DIGITAL
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Búsqueda de Dominios 
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              
                <template v-if="data?.data?.dominioSearch?.data?.info">
                  <v-card outlined class="pa-4 mb-4">
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <p><strong>Dominio:</strong> {{ data?.data?.dominioSearch?.data?.info.domain }}</p>
                        <p><strong>Organización:</strong> {{ data?.data?.dominioSearch?.data?.info.organization || 'N/D' }}</p>
                        <p><strong>Ciudad:</strong> {{ data?.data?.dominioSearch?.data?.info.city || 'N/D' }}</p>
                        <p><strong>País:</strong> {{ data?.data?.dominioSearch?.data?.info.country || 'N/D' }}</p>
                        <p><strong>LinkedIn:</strong>
                          <a v-if="data?.data?.dominioSearch?.data?.info.linkedin" :href="data?.data?.dominioSearch?.data?.info.linkedin" target="_blank">
                            Ver perfil
                          </a>
                          <span v-else>N/D</span>
                        </p>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <p><strong>Correo detectado:</strong></p>
                        <ul>
                          <li v-for="(email, i) in data?.data?.dominioSearch?.data?.info?.emails" :key="i">
                            {{ email.value }} (Confianza: {{ email.confidence }}%)
                          </li>
                        </ul>

                        <p><strong>Tecnologías:</strong></p>
                        <ul>
                          <li v-for="(tech, i) in data?.data?.dominioSearch?.data?.data?.info?.technologies" :key="'tech-' + i">
                            {{ tech }}
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                TOP 5 resultados en Google
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.top5results?.data?.length">
                  <v-card
                    v-for="(result, index) in data?.data?.top5results?.data.slice(0, 5)"
                    :key="index"
                    outlined
                    class="mb-4 pa-4"
                  >
                    <v-row>
                      <v-col cols="12">
                        <a :href="result.link" target="_blank" class="text-primary font-weight-bold">
                          {{ result.title }}
                        </a>
                        <p class="text-subtitle-2 mb-1">{{ result.displayed_link }}</p>
                        <p>{{ result.snippet }}</p>

                        <div v-if="result.rich_snippet?.top?.attributes?.length">
                          <v-divider class="my-2" />
                          <p class="text-caption font-weight-bold mb-1">Detalles:</p>
                          <ul>
                            <li
                              v-for="(attr, i) in result.rich_snippet.top.attributes"
                              :key="'attr-' + i"
                            >
                              {{ attr.name }}: {{ attr.value }}
                            </li>
                          </ul>
                        </div>

                        <div v-if="result.sitelinks?.inline?.length">
                          <v-divider class="my-2" />
                          <p class="text-caption font-weight-bold mb-1">Sitios relacionados:</p>
                          <ul>
                            <li
                              v-for="(link, i) in result.sitelinks.inline"
                              :key="'site-' + i"
                            >
                              <a :href="link.link" target="_blank">{{ link.title }}</a>
                            </li>
                          </ul>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                TOP 5 noticias en Google
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.top5Noticias?.data?.length">
                  <v-card
                    v-for="(item, index) in data?.data?.top5Noticias?.data.slice(0, 5)"
                    :key="index"
                    class="mb-4 pa-3"
                    variant="outlined"
                    >
                    <v-row>
                      <v-col cols="3" v-if="item.thumbnail">
                        <v-img
                          :src="item.thumbnail"
                          alt="thumbnail"
                          height="80"
                          cover
                          class="rounded"
                        />
                      </v-col>

                      <v-col :cols="item.thumbnail ? 9 : 12">
                        <a
                          :href="item.link"
                          target="_blank"
                          rel="noopener"
                          class="text-primary font-weight-medium text-subtitle-1"
                        >
                          {{ item.title }}
                        </a>

                        <div class="text-caption mt-1">
                          <span class="font-weight-bold">{{ item.source }}</span>
                          <span v-if="item.date"> &bull; {{ item.date }}</span>
                        </div>

                        <div class="mt-2 text-body-2">
                          {{ item.snippet }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel> 

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          VALIDACIÓN DOCUMENTAL
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Validación de QR de Situación Fiscal
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid grid-list-md>
                  <v-row>
                    <v-col cols="12" md="6">
                      <strong>Nombre o Razón Social:</strong> {{ data?.data?.situacionFiscal?.data?.nombre_razon_social }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>RFC:</strong> {{ data?.data?.situacionFiscal?.data?.rfc }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>CURP:</strong> {{ data?.data?.situacionFiscal?.data?.curp }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Régimen de Capital:</strong> {{ data?.data?.situacionFiscal?.data?.regimen_capital }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Fecha de Nacimiento / Constitución:</strong> {{ data?.data?.situacionFiscal?.data?.fecha_nacimiento_constitucion }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Inicio de Operaciones:</strong> {{ data?.data?.situacionFiscal?.data?.fecha_inicio_operaciones }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Situación del Contribuyente:</strong> {{ data?.data?.situacionFiscal?.data?.situacion_contribuyente }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Último Cambio de Situación:</strong> {{ data?.data?.situacionFiscal?.data?.fecha_ultimo_cambio_situacion }}
                    </v-col>
                    <v-col cols="12">
                      <strong>Domicilio:</strong><br>
                      {{ data?.data?.situacionFiscal?.data?.tipo_vialidad }} {{ data?.data?.situacionFiscal?.data?.nombre_vialidad }} No. {{ data?.data?.situacionFiscal?.data?.numero_exterior }} {{ data?.data?.situacionFiscal?.data?.numero_interior ? ('Int. ' + data?.data?.situacionFiscal?.data?.numero_interior) : '' }},
                      {{ data?.data?.situacionFiscal?.data?.colonia }}, {{ data?.data?.situacionFiscal?.data?.municipio_delegacion }}, {{ data?.data?.situacionFiscal?.data?.entidad_federativa }}, CP {{ data?.data?.situacionFiscal?.data?.cp }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Correo Electrónico:</strong> {{ data?.data?.situacionFiscal?.data?.correo_electronico }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Regímenes Fiscales:</strong>
                      <ul class="ma-0 pa-0">
                        <li>{{ data?.data?.situacionFiscal?.data?.regimen }}</li>
                        <li>{{ data?.data?.situacionFiscal?.data?.regimen_ }}</li>
                      </ul>
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Fecha de Alta:</strong> {{ data?.data?.situacionFiscal?.data?.fecha_alta }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Enlace oficial del SAT:</strong>
                      <a :href="data?.data?.situacionFiscal?.data?.url_sat" target="_blank">{{ data?.data?.situacionFiscal?.data?.url_sat }}</a>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>

            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Comprobante de Domicilio
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p>Sin coincidencias encontradas.</p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  name: 'ReportePersonaMoral',
  data() {
    return {
      data: {},
      comentarios: '',
      loading: false,
      analysis: '',
      response: {},
      isLoading: false,
    };
  },
  methods: {
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    getReport() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/check/report/${this.$route.params.idReport}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      }).then((response) => {
        this.isLoading = false;
        this.data = response.data.data;
      }).catch((error) => {
        this.isLoading = false;
        this.mixError(error.response?.data?.message || "Ocurrió un error");
        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      });
    },
    downloadCertificate(base64Data, fileName = 'certificado') {
      // Decodificar base64
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Crear un blob
      const blob = new Blob([byteArray], { type: 'application/x-x509-ca-cert' });

      // Crear un enlace temporal
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.cer`;
      link.click();

      // Limpiar memoria
      URL.revokeObjectURL(link.href);
    },
    async analyzeWithAI() {
      this.loading = true;
      const payload = {
        sReportId: this.$route.params.idReport,
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/check/analyzeReport`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
        });
        this.analysis = response.data.data;
      } catch (error) {
        this.analysis = "Ocurrió un error al obtener el análisis.";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getReport();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.landing[this.selectLanguage];
      }
    },
  },
};
</script>

<style>
.panel-header {
  background-color: black;
  color: white;
  font-family: 'montserrat-bold';
  border-radius: 16px;
}
.panel-header .v-expansion-panel-header__icon i {
  color: white !important;
}
.text-body-2 {
  animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
